import UserService from '@/services/user.service';
import axios from "axios";

export const consultantModule = {
    namespaced: true,
    state: {
        requests: [],
        consultant: {},
        consultants: new Map(),
        studentsForConsultant: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createConsultant({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createConsultant");
            data.role_id = '$consultant'
            return UserService.createUser(axiosSource, data).then(
                async data => {
                    commit('insertConsultant', data)
                    await dispatch('clearRequest', "createConsultant");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateConsultant({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateConsultant");
            return UserService.updateUser(axiosSource, data).then(
                async data => {
                    commit('updateConsultantData', data)
                    await dispatch('clearRequest', "updateConsultant");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteConsultant({commit, dispatch}, consultantId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteConsultant");
            return UserService.deleteUser(axiosSource, consultantId).then(
                async data => {
                    commit('removeConsultantFromList', consultantId)
                    await dispatch('clearRequest', "deleteConsultant");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        listConsultants({commit}) {
            return UserService.listUsersByRole('$consultant').then(
                data => {
                    commit('updateConsultantsList', data);
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listStudentsForConsultant({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listStudentsForConsultant");
            return UserService.listStudentsForConsultant(axiosSource).then(
                async data => {
                    commit('updateStudentsForConsultantList', data)
                    await dispatch('clearRequest', "listStudentsForConsultant");
                    return Promise.resolve(data)
                },
                error => {
                    return Promise.reject(error)
                }
            )
        },
        async adminListStudentsForConsultant({commit, dispatch}, consultantId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "adminListStudentsForConsultant");
            return UserService.adminListStudentsForConsultant(axiosSource, consultantId).then(
                async data => {
                    commit('updateStudentsForConsultantList', data)
                    await dispatch('clearRequest', "adminListStudentsForConsultant");
                    return Promise.resolve(data)
                },
                error => {
                    return Promise.reject(error)
                }
            )
        },
        async syncStudentsForConsultant({commit, dispatch}, {consultantId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "syncStudentsForConsultant");
            return UserService.syncStudentsForConsultant(axiosSource, consultantId, data).then(
                async data => {
                    commit('updateStudentsForConsultant', data)
                    await dispatch('clearRequest', "syncStudentsForConsultant");
                    return Promise.resolve(data)
                },
                error => {
                    return Promise.reject(error)
                }
            )
        },
    },
    mutations: {
        updateConsultantsList(state, data) {
            state.consultants = new Map()
            for (const entity of data) {
                entity.phone = entity.phone?.replace('+98', '0')
                state.consultants.set(entity.id, entity)
            }
        },
        insertConsultant(state, data) {
            data.phone = data.phone?.replace('+98', '0')
            state.consultants.set(data.id, data)
        },
        updateConsultantData(state, data) {
            data.phone = data.phone?.replace('+98', '0')
            state.consultants.set(data.id, data)
        },
        removeConsultantFromList(state, consultantId) {
            state.consultants.delete(consultantId)
        },
        updateStudentsForConsultantList(state, data) {
            state.studentsForConsultant = new Map()
            for (const entity of data.students) {
                entity.phone = entity.phone?.replace('+98', '0')
                state.studentsForConsultant.set(entity.id, entity)
            }
        },
        updateStudentsForConsultant(state, data) {
            state.studentsForConsultant = data.students
        },
    }
};